(() => {
  // Size guide dialog + in/cm toggle (remembered per visitor).
  const units = (() => { try { return localStorage.getItem('gp-units') || 'in'; } catch (e) { return 'in'; } })();
  const setUnits = (u, root) => {
    (root || document).querySelectorAll('[data-units-root], .gp-size').forEach((el) => el.setAttribute('data-units', u));
    document.querySelectorAll('[data-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unit === u)));
    try { localStorage.setItem('gp-units', u); } catch (e) {}
  };
  setUnits(units);
  // Highlight only helps when a product covers part of the range.
  document.querySelectorAll('.gp-size table').forEach((t) => {
    const rows = t.querySelectorAll('tbody tr'), here = t.querySelectorAll('tbody tr.is-here');
    if (here.length === rows.length) t.classList.add('is-all');
    const note = t.closest('.gp-size') && t.closest('.gp-size').querySelector('.gp-size__only');
    if (note && here.length && here.length < rows.length) note.classList.add('is-on');
  });
  document.addEventListener('click', (e) => {
    const u = e.target.closest('[data-unit]'); if (u) setUnits(u.dataset.unit);
    const open = e.target.closest('[data-size-open]');
    const dlg = document.querySelector('[data-size-dialog]');
    if (open && dlg) { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); }
    if (e.target.closest('[data-size-close]') && dlg) dlg.close();
    if (dlg && e.target === dlg) dlg.close();
  });
})();
